import { TrendingDownIcon, TrendingUpIcon } from 'lucide-react';

import { AnalysisSubHeader } from '../../../components';
import { TintedListCard } from './TintedListCard';
import { useTranslation } from 'react-i18next';

interface MarketForcesProps {
  macroFactors?: {
    headwinds?: string[];
    tailwinds?: string[];
  };
}

export const MarketForces = ({ macroFactors }: MarketForcesProps) => {
  const { t } = useTranslation('analysis');

  const { headwinds, tailwinds } = macroFactors ?? {};
  if (!headwinds?.length && !tailwinds?.length) return null;

  return (
    <div className="flex flex-col gap-6">
      <AnalysisSubHeader
        title={t('analysisResult.marketForces.marketForces')}
        subtitle={t('analysisResult.marketForces.headwindsAndTailwindsShapingTheCategory')}
        subtitleTone="meta"
      />
      <div className="grid grid-cols-1 items-stretch gap-3 md:grid-cols-2">
        {headwinds && headwinds.length > 0 && (
          <TintedListCard
            tone="warning"
            icon={TrendingDownIcon}
            title={t('analysisResult.marketForces.marketHeadwinds')}
            items={headwinds}
          />
        )}
        {tailwinds && tailwinds.length > 0 && (
          <TintedListCard
            tone="positive"
            icon={TrendingUpIcon}
            title={t('analysisResult.marketForces.marketTailwinds')}
            items={tailwinds}
          />
        )}
      </div>
    </div>
  );
};
